import { useEffect, useState } from "react";

export function useLocations() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch("/api/locations")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch locations");
        }
        return response.json();
      })
      .then((locations) => setData(locations))
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, []);
  return {
    data,
    loading,
    error
  };
}
